import { faCardsBlank, faCoinFront } from '@fortawesome/pro-duotone-svg-icons'
import { Box, Card, Stack } from '@mui/material'
import { m } from 'framer-motion'
import { memo } from 'react'

import scratchCover from 'assets/scratch-cover.jpg'
import { SCRATCH_CARD_VALUE } from '../../constants/game'
import { Image } from '../shared/image'
import { Label } from '../shared/label'
import Button from '../shared/button/Button'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import Text from '../shared/text/Text'
import RevealGrid from './RevealGrid'

const ScratchCard = ({
  t,
  onOpenScratchCard,
  gameProfile: { scratchStatus, result },
  onCompleteScratch,
  symbol,
  currentUserPoints
}) => {
  const noEnoughPoints = currentUserPoints < SCRATCH_CARD_VALUE
  const openScratchCardAction = (
    <Button
      label={t('game.open-scratch-card')}
      onClick={onOpenScratchCard}
      endIcon={<FaIcon icon={faCardsBlank} />}
      disabled={noEnoughPoints}
    />
  )
  return (
    <Card
      sx={{
        p: 3,
        display: 'flex',
        gap: 3,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}
    >
      {scratchStatus === 0 && (
        <Image
          src={scratchCover}
          sx={{ ratio: '1/1', width: 1, borderRadius: 1.5 }}
          disablePlaceholder
        />
      )}
      {scratchStatus === 1 && (
        <Box
          sx={{
            width: 1,
            aspectRatio: '1/1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            flexDirection: 'column'
          }}
        >
          <FaIcon icon={faCardsBlank} shake fontSize={200} />
          <Text variant='subtitle2' label={t('game.unpacking')} />
        </Box>
      )}
      {scratchStatus === 2 && (
        <RevealGrid
          value={result}
          t={t}
          onCompleteScratch={onCompleteScratch}
        />
      )}
      {scratchStatus === 0 && (
        <Stack spacing={3} alignItems='center'>
          <Label startIcon={faCoinFront} color='primary'>
            {t('game.amount-to-scratch', {
              value: SCRATCH_CARD_VALUE,
              symbol
            })}
          </Label>
          {noEnoughPoints ? (
            openScratchCardAction
          ) : (
            <m.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }}
            >
              {openScratchCardAction}
            </m.div>
          )}
        </Stack>
      )}
    </Card>
  )
}

export default memo(ScratchCard)
